import type {ICountryConfiguration} from './types'

const NO: ICountryConfiguration = {}

export default NO
